import { APIConfig, DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { DataService } from 'common/services/data-services/base-data-services/data.service';

export abstract class BaseWidgetService<T extends DataModel> {
    constructor(protected baseDataService: DataService<T>) { }
    public abstract getMetaModel(): MetaModel;

    getDataModel() {
        return new Promise((resolve, reject) => {
            
            resolve(this.baseDataService.createInstance());
        });
    }

    prepareMetaModel(dataModel: DataModel, metaModel: SmMetaModel, routeData: WidgetModel): Promise<SmMetaModel> {
        return new Promise<SmMetaModel>((resolve, reject) => {
            resolve(metaModel);
        });
    }

    async getBlankObject(): Promise<T> {
        return await new Promise<T>((resolve, reject) => {
            const instance = this.baseDataService.createInstance();
            resolve(instance);
        });
    }

    getDataById(params: any): Promise<T[]> {
        return new Promise((resolve, reject) => {
            resolve(this.baseDataService.getData(params));
        });
    }

    postDataToCustomEndPoint(body: any): Promise<T[]> {
        return new Promise((resolve, reject) => {
            resolve(this.baseDataService.postDataToCustomEndPoint(body));
        });
    }

    postDataToEditTable(body: any,url:string=''): Promise<T[]> {
        return new Promise((resolve, reject) => {
            resolve(this.baseDataService.postDataToGridEdit(body,null,url));
        });
    }

    getListDataModel(queryParam, params = null): Promise<any> {
        return new Promise((resolve, reject) => {
            Promise.resolve()
                .then(() => {
                    return this.baseDataService.getData();
                })
                .then(listResponse => {
                    resolve(listResponse);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    postDatatoAPI(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.baseDataService
                .postData(data)
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getDataFromMultipleAPI(): Promise<any> {
        const urlList = this.getUrlList();
        return new Promise((resolve, reject) => {
            this.baseDataService
                .apiCallFromMultipleAPIforGrid(urlList)
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
 
    getDataForGrids(urlList): Promise<any> {
        return new Promise((resolve, reject) => {
            this.baseDataService
                .apiCallFromMultipleAPIforGrid(urlList)
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    fetchSignedUrl(url): any {
        return this.baseDataService.fetchSignedUrl(url);
    }

    // async setsystemData(dataKeyName, apiConstant) {
    //     return await new Promise<T[]>((resolve, reject) => {
    //         this.baseDataService.setSystemServiceData(dataKeyName, apiConstant).then(data => {
    //         });
    //     });
    // }

    getUrlList(): any[] {
        return [''];
    }
    verifyCTABody(body: any) {
        return true;
    }
}
